var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addActivity app-container" },
    [
      _c(
        "div",
        { staticClass: "activeClass" },
        [
          _c(
            "el-steps",
            {
              attrs: {
                active: _vm.active,
                "finish-status": "success",
                "process-status": "finish",
                "align-center": "",
              },
            },
            [
              _c("el-step", { attrs: { title: "活动填写" } }),
              _c("el-step", { attrs: { title: "下发经销商" } }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.active == 0
        ? _c("BasicInformation", {
            ref: "BasicInformation",
            attrs: { activity: _vm.activity, "class-type": _vm.classType },
            on: {
              "update:activity": function ($event) {
                _vm.activity = $event
              },
              "update:classType": function ($event) {
                _vm.classType = $event
              },
              "update:class-type": function ($event) {
                _vm.classType = $event
              },
            },
          })
        : _vm._e(),
      _vm.active == 0
        ? _c("reimburseInformation", {
            attrs: { activity: _vm.activity },
            on: {
              "update:activity": function ($event) {
                _vm.activity = $event
              },
            },
          })
        : _vm._e(),
      _vm.active == 1
        ? _c("dealerList", {
            ref: "dealerListDom",
            attrs: { "model-table": _vm.modelTable, "act-plan": _vm.activity },
            on: {
              "update:modelTable": function ($event) {
                _vm.modelTable = $event
              },
              "update:model-table": function ($event) {
                _vm.modelTable = $event
              },
              "update:actPlan": function ($event) {
                _vm.activity = $event
              },
              "update:act-plan": function ($event) {
                _vm.activity = $event
              },
            },
          })
        : _vm._e(),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { offset: 10 } },
            [
              _c(
                "vxe-button",
                {
                  staticStyle: { "margin-top": "12px" },
                  on: { click: _vm.returnListFun },
                },
                [_vm._v("返回")]
              ),
              _vm.active > 0
                ? _c(
                    "vxe-button",
                    {
                      staticStyle: { "margin-top": "12px" },
                      on: { click: _vm.LastStepFun },
                    },
                    [_vm._v("上一步")]
                  )
                : _vm._e(),
              _vm.active == 0
                ? _c(
                    "vxe-button",
                    {
                      staticStyle: { "margin-top": "12px" },
                      attrs: { status: "success", loading: _vm.loading },
                      on: { click: _vm.addActplanInfoFun },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _vm.active == 1
                ? _c(
                    "vxe-button",
                    {
                      staticStyle: { "margin-top": "12px" },
                      attrs: { status: "success", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.addBatchActplanDealer(0)
                        },
                      },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _vm.active == 1
                ? _c(
                    "vxe-button",
                    {
                      staticStyle: { "margin-top": "12px" },
                      attrs: { status: "primary", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.addBatchActplanDealer(1)
                        },
                      },
                    },
                    [_vm._v("保存并发布")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }